import { useApiQuery } from '@portals-platform/api-client';
import { useMemo } from 'react';
import type { Page } from '../api/common.js';
import { ENDPOINTS } from '../api/endpoints.js';
import type { CaptivePolicyResponse } from '../api/responses.js';
import { toCaptivePolicies } from '../mappers/mappers.js';
import type { CaptivePolicy } from '../models.js';
import { queryKeys } from '../query-keys.js';

export function useCaptivePolicies(): CaptivePolicy[] {
  const { data } = useApiQuery<Page<CaptivePolicyResponse>>(
    [...queryKeys.captivePolicies()],
    ENDPOINTS.captivePolicies,
    { params: { page: 0, size: 100, sort: 'createdAt' } },
  );

  return useMemo(() => toCaptivePolicies(data), [data]);
}
